import EmailApprovals from "./EmailApprovals";
import EmailShipments from "./EmailShipments";
import EmailWorkOrders from "./EmailWorkOrders";

export default function EmailCrmLayout({ selectedCustomer }) {
  /* ******************** All States ************************* */

  /* ******************** All Functions ************************* */
  // get list of customers related to fromEmail Company

  /* ******************** All UseEffects ************************* */

  return (
    <>
      <div className="bg-white shadow-sm p-2 rounded-3">
        <EmailWorkOrders height="18vh" selectedCustomer={selectedCustomer} />
      </div>
      <div className="bg-white shadow-sm p-2 rounded-3">
        <EmailApprovals height="18vh" selectedCustomer={selectedCustomer} />
      </div>
      <div className="bg-white shadow-sm p-2 rounded-3">
        <EmailShipments height="18vh" selectedCustomer={selectedCustomer} />
      </div>
    </>
  );
}
